import React from 'react'

import GlobalLoader from 'compositions/GlobalLoader/GlobalLoader'

import useAbFtData from './util/useAbFtData'
import AbFtContext from './AbFtContext'


const AbFtProvider: React.CFC = ({ children }) => {
  const data = useAbFtData()

  if (!data) {
    return (
      <GlobalLoader />
    )
  }

  return (
    <AbFtContext.Provider value={data}>
      {children}
    </AbFtContext.Provider>
  )
}


export default AbFtProvider
